import React, { ReactElement, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Component as RightArrowIcon } from 'icons/icon-ui--arrow-next.svg';
import { Component as LeftArrowIcon } from 'icons/icon-ui--arrow-prev.svg';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { BreakpointMedia } from '../../utils/config';
import styles from './LimitedTimeOffering.module.scss';
import CurrentRecipeSelector from './CurrentRecipeSelector';
import { LtoItem } from '../../models/product.types';
import { useMenuWithCart } from '../../contexts/MenuWithCart';

interface Props {
  setCurrentRecipe?: ((index: any) => void) | null;
  currentRecipe: number;
  ltoItem?: LtoItem;
  totalNumberOfRecipes: number;
  handleLoggedInBreadcrumbClick: (menuId: number, cartId: number) => void;
  breadcrumbText: string;
}

function RecipeImages({
  ltoItem,
  currentRecipe,
  setCurrentRecipe,
  totalNumberOfRecipes,
  handleLoggedInBreadcrumbClick,
  breadcrumbText,
}: Props): ReactElement {
  const {
    menu,
    cart,
  } = useMenuWithCart();
  const stackElements = !useMediaQuery({ query: BreakpointMedia.MIN_LTO });
  const [direction, setDirection] = useState<'left' | 'right'>('right');

  const prevSlide = () => {
    setDirection('left');
    if (setCurrentRecipe) {
      setCurrentRecipe((prevIndex) => (prevIndex === 0
        ? totalNumberOfRecipes : prevIndex - 1));
    }
  };
  const nextSlide = () => {
    setDirection('right');
    if (setCurrentRecipe) {
      setCurrentRecipe((prevIndex) => (prevIndex === totalNumberOfRecipes
        ? 0 : prevIndex + 1));
    }
  };

  return (
    <>
      <div className={styles.image_section}>
        {stackElements && (
          <div className={styles.breadcrumbs}>
            <a
              className={styles.week_of}
              role="button"
              onClick={() => menu && cart && handleLoggedInBreadcrumbClick(menu?.id, cart?.id)}
            >
              {breadcrumbText}
            </a>
            <span className={styles.separator}>/</span>
            Eat To Hustle
          </div>
        )}
        <div className={styles.image_container}>
          <TransitionGroup component={null}>
            <CSSTransition
              key={currentRecipe}
              timeout={300}
              classNames={`slide-${direction}`}
            >
              <div
                className={`${styles.img} ${styles[`robin-${currentRecipe}`]}`}
              >
                <button
                  onClick={prevSlide}
                  type="button"
                  className={styles.slider_buttons}
                >
                  <LeftArrowIcon width={30} />
                </button>
                <button
                  onClick={nextSlide}
                  type="button"
                  className={styles.slider_buttons}
                >
                  <RightArrowIcon width={30} />
                </button>
              </div>
            </CSSTransition>
          </TransitionGroup>
        </div>
        <CurrentRecipeSelector
          ltoItem={ltoItem}
          currentLTORecipe={currentRecipe}
          setCurrentLTORecipe={setCurrentRecipe}
        />
      </div>
    </>
  );
}

export default RecipeImages;
